import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MapComponent } from './map/map.component';

// Routes for URL parameters
const routes: Routes = [
  { path: '', component: MapComponent },
  { path: 'lat/:lat/lng/:lng/z/:z', component: MapComponent },
];

@NgModule({
  declarations: [],
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
